import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'filter'})

export class FilterPipe implements PipeTransform {

	constructor() { }

	transform(arr: any[], args: any): any[] {
		const argCount = Object.keys(args).length;
		const ret = arr.filter((item: any) => {
			if (typeof item === 'object' && typeof args === 'object') {
				let matches = 0;
				for (const key in item) {
					if (item[key] === args[key]) {
						matches++;
					}
				}
				return matches === argCount;
			}
			if (typeof item === 'string' && typeof args === 'string' && item === args) {
				return true;
			}
		});
		return ret;
	}
}
